import { render, staticRenderFns } from "./os-default.vue?vue&type=template&id=37f249a2&scoped=true"
import script from "./os-default.vue?vue&type=script&lang=js"
export * from "./os-default.vue?vue&type=script&lang=js"
import style0 from "./os-default.vue?vue&type=style&index=0&id=37f249a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f249a2",
  null
  
)

export default component.exports